import { render, staticRenderFns } from "./FleetCentrum.vue?vue&type=template&id=4fb363ae&"
import script from "./FleetCentrum.vue?vue&type=script&lang=ts&"
export * from "./FleetCentrum.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports